import React, { useState, useEffect } from 'react'
import styled from 'styled-components';
import axios from 'axios';
import * as _ from 'lodash';
import { Descriptions, Spin, Empty } from 'antd';

const TaskHistory = ({task}) => {

  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const getHistory = (options) => {
    axios.post('/api/wt/workflow/dto/history/read', { ...options }).then(
      res => { 
        setHistory(res.data.data);
        setLoading(false);
      }
    ).catch(error => {
      alert(`Error loading history.`)
      console.error(error);
      setLoading(false);  
    });
  };

  useEffect(() => {
    !_.isEmpty(task) && getHistory(task);
  }, [task])

  return (
    <>
      {!loading &&
      <>
      {!_.isEmpty(history) &&
              <HistoryContainer>
                {history.map((h, i) => (
                  <Descriptions
                    bordered key={i}
                    size="small"
                    style={{marginBottom: '10px'}}
                  >
                    <Descriptions.Item label="Date" span={3}>{h.date}</Descriptions.Item>
                    <Descriptions.Item label="User" span={3}>{h.user}</Descriptions.Item>
                    <Descriptions.Item label="Vote" span={3}>{h.vote}</Descriptions.Item>
                    <Descriptions.Item label="Comments" span={3}>{h.comments}</Descriptions.Item>
                  </Descriptions>
                ))}
            </HistoryContainer>
          }
          {_.isEmpty(history) &&
            <Empty style={{paddingTop: '10px'}} image={Empty.PRESENTED_IMAGE_SIMPLE} description="No history found"/>
          }
        </>
      }
      {loading &&
        <Spinner>
          <Spin />
        </Spinner>
      }
    </>
  )
}

const HistoryContainer = styled.div`
  padding: 10px;
  .ant-descriptions-item-label {
    width: 110px;
  },
  .ant-descriptions-item-label,
  .ant-descriptions-item-content {
    font-size: 13px;
  }
`
const Spinner = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export default TaskHistory;
